import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import {
  Container,
  Grid,
  IconButton,
  Typography,
  Backdrop,
  Box,
  Button,
  Modal,
  CircularProgress,
} from "@mui/material";

import { postNotification } from "../../../components/utilities/Notifications";
import ModalLoadingFull from "../../../components/modals/ModalLoadingFull";

import {
  BCPCircleXmark,
  BCPDownToLine,
  BCPXmark,
} from "../../../components/icons/bcp/BCPIcons";

import { AdminTabs } from "../Admin";
import GenericPicker from "../../../components/utilities/GenericPicker";

import moment from "moment";
import "moment-timezone";
import DatePickerComponent from "../../../components/utilities/DatePickerComponent";
import GameSystemPicker from "../../../components/utilities/gamesystempickers/GameSystemPicker";
import { globalVariables } from "../../../global/GlobalVariables";
import {
  getGameSystems,
  handlePagingAll,
} from "../../../components/api/APIUtilities";
import ListResponsive from "../../../components/other/ListResponsive";
import {
  delay,
  getData,
  postData,
} from "../../../components/utilities/UtilityFunctions";
import { getLocalStorage } from "../../../components/layout/cookies/CookieFunctions";

export default function AdminExports(props) {
  const { activeTab, handleTabChange, authContext } = props;

  const [processing, setProcessing] = useState(true);

  const [exportModalOpen, setExportModalOpen] = useState(false);
  const [exportTypes, setExportTypes] = useState(null);
  const [adminExports, setAdminExports] = useState(null);

  var initalGameSystems = [];
  if (authContext?.authState?.cookieConsent) {
    var getGetCachedData = getLocalStorage(`gameSystems`);
    if (getGetCachedData) {
      initalGameSystems = JSON.parse(getGetCachedData);
    }
  }
  const [gameSystems, setGameSystems] = useState(initalGameSystems);

  const fetchExports = async () => {
    setAdminExports(null);
    var apiExports = await handlePagingAll(`/admin/exports`, {
      limit: 100,
      sortAscending: false,
    });
    setAdminExports(apiExports);
  };

  useEffect(() => {
    const go = async () => {
      try {
        setExportTypes(null);
        setAdminExports(null);
        var apiOptions = await getData(`/admin/options`, {});
        if (apiOptions.exports) {
          apiOptions.exports = apiOptions.exports.map((option) => {
            return {
              ...option,
              value: option.exportType,
              label: option.name,
            };
          });

          setExportTypes(apiOptions.exports);
        }
        var _gameSystems = await getGameSystems();
        setGameSystems(_gameSystems);
        setProcessing(false);
        await fetchExports();
      } catch (err) {
        postNotification("error", err);
      }
    };
    go();
  }, []);

  return (
    <Container sx={{ pt: 2, pb: 2 }} maxWidth="lg">
      <Grid container sx={{ gap: 2 }}>
        <Grid
          item
          xs={12}
          sx={{
            p: 2,
            borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
            borderRadius: 1,
            boxShadow: 1,
            backgroundColor: "background.secondary",
          }}
        >
          <Typography variant="h3">Admin Settings</Typography>

          <AdminTabs
            activeTab={activeTab}
            handleTabChange={handleTabChange}
            authContext={authContext}
          />
        </Grid>

        <Grid
          item
          xs={12}
          sx={{
            p: 2,
            borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
            borderRadius: 1,
            boxShadow: 1,
            backgroundColor: "background.secondary",
          }}
        >
          <ListResponsive
            originalList={adminExports}
            doSearch
            doPages
            initialRowsPerPage={10}
            rowsPerPageArray={[10, 20, 50, 100, { label: "All", value: -1 }]}
            actionButton={[
              {
                props: {
                  variant: "contained",
                  color: "primary",
                  onClick: (e) => {
                    setExportModalOpen(true);
                  },
                },
                label: "New Export",
              },
            ]}
            searchProps={{
              label: "Search Exports",
              performSearch: (originalList, searchText) => {
                if (!searchText || searchText === "") {
                  return originalList;
                } else {
                  var filteredList = originalList.filter(function (el) {
                    if (el?.name?.toLowerCase().includes(searchText))
                      return true;
                    if (el?.status?.toLowerCase().includes(searchText))
                      return true;

                    return false;
                  });
                  return filteredList;
                }
              },
            }}
            rowProps={{
              headings: <ListRow heading={true} />,
              mapFunction: (row, index) => (
                <ListRow key={index} row={row} setProcessing={setProcessing} />
              ),
            }}
          />
        </Grid>
      </Grid>

      {exportModalOpen && (
        <NewExportsModal
          adminExports={adminExports}
          setAdminExports={setAdminExports}
          exportTypes={exportTypes}
          gameSystems={gameSystems}
          exportModalOpen={exportModalOpen}
          setExportModalOpen={setExportModalOpen}
          setProcessing={setProcessing}
          authContext={authContext}
        />
      )}

      {Boolean(processing) && <ModalLoadingFull />}
    </Container>
  );
}

function NewExportsModal(props) {
  const {
    adminExports,
    setAdminExports,

    exportTypes,
    gameSystems,
    exportModalOpen,
    setExportModalOpen,
    setProcessing,

    authContext,
  } = props;

  const globalVars = globalVariables();
  const [exportType, setExportType] = useState(null);

  return (
    <Modal
      disableAutoFocus
      open={exportModalOpen}
      onClose={() => {
        setExportModalOpen(false);
      }}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: ["95vw", "85vw", 600],
          maxHeight: "95vh",
          overflowY: "scroll",
          bgcolor: "background.paper",
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: 1,
          boxShadow: 24,
          p: 4,
        }}
      >
        <IconButton
          aria-label="cancel"
          color="error"
          sx={{ position: "absolute", top: "4px", right: "4px" }}
          onClick={() => {
            setExportModalOpen(false);
          }}
        >
          <BCPXmark />
        </IconButton>
        <Grid
          container
          spacing={2}
          sx={{
            pb: 1,
            mb: 2,
            borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
          }}
        >
          <Grid item xs>
            <Typography variant="h4" component="h2">
              Export Options
            </Typography>
          </Grid>
        </Grid>

        <Formik
          initialValues={{
            exportType: "",
            startDate: new Date(moment().subtract(1, "week").startOf("day")),
            endDate: new Date(moment().endOf("day")),
          }}
          enableReinitialize={true}
          validationSchema={Yup.object().shape({
            exportType: Yup.string().required(),
          })}
          onSubmit={async (values) => {
            try {
              var exportType = exportTypes.filter(
                (exportType) => exportType.value === values.exportType
              )?.[0];
              if (!exportType) {
                postNotification("error", "Invalid export type");
                return;
              }

              var body = {};
              if (values.startDate !== undefined && values.startDate !== "") {
                body.startDate = moment(values.startDate)
                  .startOf("day")
                  .format();
              }
              if (values.endDate !== undefined && values.endDate !== "") {
                body.endDate = moment(values.endDate).endOf("day").format();
              }

              if (body.startDate && body.endDate) {
                if (moment(body.startDate).isAfter(moment(body.endDate))) {
                  let error = new Error(
                    "Start Date must be before the End Date"
                  );
                  error.name = "Validation Error";
                  throw error;
                }
              }

              if (typeof values.gameType === "number") {
                body.gameType = values.gameType;
              }
              if (
                values.eventSubType !== undefined &&
                values.eventSubType !== ""
              ) {
                body.eventSubType = values.eventSubType;
              }

              setProcessing(true);
              var apiExport = await postData(exportType?.path, {
                body: body,
              });
              setAdminExports([apiExport, ...adminExports]);
              postNotification(
                "info",
                "Your export has been sent to our queue"
              );

              setExportType(null);
              setExportModalOpen(false);
              setProcessing(false);
            } catch (err) {
              postNotification("error", err);
            }
          }}
        >
          {({
            errors,
            handleChange,
            handleSubmit,
            touched,
            values,
            setFieldValue,
          }) => (
            <form onSubmit={handleSubmit}>
              <Grid
                container
                spacing={2}
                sx={{
                  pb: 1,
                  mb: 2,
                }}
              >
                <Grid item xs={12}>
                  <GenericPicker
                    label="Export Type"
                    name="exportType"
                    required
                    inclAny={false}
                    list={exportTypes}
                    value={values.exportType}
                    handleChange={(e) => {
                      handleChange(e);

                      if (values.gameType !== undefined) {
                        setFieldValue("gameType", "");
                      }
                      if (values.eventSubType !== undefined) {
                        setFieldValue("eventSubType", "");
                      }
                      setExportType(
                        e.target?.value
                          ? exportTypes.filter(
                              (exportType) =>
                                exportType.value === e.target?.value
                            )?.[0]
                          : null
                      );
                    }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <DatePickerComponent
                    name="startDate"
                    label="Start Date"
                    value={values.startDate}
                    setFieldValue={setFieldValue}
                  />
                </Grid>
                <Grid item xs={12}>
                  <DatePickerComponent
                    name="endDate"
                    label="End Date"
                    value={values.endDate}
                    setFieldValue={setFieldValue}
                  />
                </Grid>

                {exportType?.queryOptions?.length > 0 &&
                  exportType.queryOptions.map((option, index) => {
                    if (option.name === "gameType") {
                      return (
                        <Grid item xs={12} key={index}>
                          <GameSystemPicker
                            name="gameType"
                            value={values.gameType}
                            handleChange={handleChange}
                            gameSystems={gameSystems}
                            touched={touched.gameType}
                            error={errors.gameType}
                            allowAny={
                              !authContext?.authState?.identity
                                ?.adminGameSystems?.length
                            }
                            required={
                              authContext?.authState?.identity?.adminGameSystems
                                ?.length > 0
                            }
                          />
                        </Grid>
                      );
                    }

                    if (
                      option.name === "eventSubType" &&
                      globalVars?.eventSubTypes?.list?.length > 0
                    ) {
                      return (
                        <Grid item xs={12} key={index}>
                          <GenericPicker
                            name="eventSubType"
                            label={
                              globalVars?.eventSubTypes?.label ||
                              "Event Sub Type"
                            }
                            value={values.eventSubType}
                            handleChange={handleChange}
                            list={globalVars.eventSubTypes.list || []}
                            inclAny={true}
                          />
                        </Grid>
                      );
                    }

                    return <></>;
                  })}

                <Grid item xs={12}>
                  <Button
                    type="submit"
                    color={"primary"}
                    variant={"contained"}
                    fullWidth
                    disabled={!exportType?.exportType}
                  >
                    Export
                  </Button>
                </Grid>
              </Grid>
            </form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
}

function ListRow(props) {
  const { heading, row, setProcessing } = props;

  const [status, setStatus] = useState(null);

  const fetchFile = async (fileId) => {
    if (!fileId) return;

    var returnObj;
    try {
      returnObj = await getData(`/admin/exports/${fileId}`, {});
    } catch (err) {
      console.error(err);
    }
    return returnObj;
  };

  const pollFile = async (fileId) => {
    if (!fileId) return;

    var returnObj;
    try {
      returnObj = await getData(`/admin/exports/${fileId}`, {});
      if (returnObj.status === status) {
        await delay(5000);
        returnObj = await pollFile(fileId);
      }
    } catch (err) {
      console.error(err);
    }
    return returnObj;
  };

  useEffect(() => {
    const go = async () => {
      if (heading || !status) {
        return;
      }
      if (row.id && status !== "failed" && status !== "complete") {
        var apiFile = await pollFile(row.id);
        setStatus(apiFile.status);
      }
    };
    go();
    // eslint-disable-next-line
  }, [status]);

  useEffect(() => {
    const go = async () => {
      if (heading) {
        return;
      }
      setStatus(row.status);
    };
    go();
    // eslint-disable-next-line
  }, [props]);

  return (
    <Grid
      item
      xs={12}
      sx={{
        p: 1,
        mb: 1,
        border: "1px solid rgba(0, 0, 0, 0.12)",
        borderRadius: 1,
        boxShadow: 1,
        backgroundColor: heading ? "table.headerBackground" : "inherit",
        color: heading ? "table.headerColor" : "inherit",
      }}
    >
      <Grid container spacing={1}>
        <Grid item xs={4}>
          <Typography variant="body1">
            {heading ? "Export" : row.name}
          </Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography variant="body1">{heading ? "Status" : status}</Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography variant="body1">
            {heading
              ? "Date"
              : moment(row.created_at).format("YYYY-MM-DD HH:mm")}
          </Typography>
        </Grid>
        <Grid item xs={2} textAlign="right">
          {status === "complete" ? (
            <IconButton
              color="primary"
              onClick={async () => {
                setProcessing(true);
                try {
                  var apiFile = await fetchFile(row.id);
                  if (apiFile.url) {
                    window.open(apiFile.url, "_blank");
                  } else {
                    postNotification("error", "Error downloading file");
                  }
                } catch (err) {
                  postNotification("error", err);
                }
                setProcessing(false);
              }}
            >
              <BCPDownToLine />
            </IconButton>
          ) : status === "failed" ? (
            <IconButton color="error" disabled>
              <BCPCircleXmark />
            </IconButton>
          ) : status && status !== "" ? (
            <IconButton color="primary" disabled>
              <CircularProgress size={24} />
            </IconButton>
          ) : (
            <></>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}
